import { cs as cs$1 } from 'date-fns/locale';
import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var cs = {
  language: 'cs',
  country: 'cz',
  name: 'Čeština',
  embeddedLocale: merge(error, login),
  flags: ['CZ'],
  dateFns: cs$1,
  format: {
    date: 'd.MM.yyyy',
    dateTime: '$t(format:date) $t(format:time)',
    time: 'HH:mm',
  },
};

export { cs as default };
